export class LockedList {
    public employeeName: string;
    public employeeId: string;
    public action: string;
    public days: any;
    public checked: Boolean;
    public comment: string;
    public reason: string;
    public requestedFlag: boolean;
    constructor(data: any) {
        this.employeeName = data.Empname ? data.Empname : '';
        this.employeeId = data.Empno ? data.Empno : '';
        this.action = data.lockedDetails.isLocked ? 'Unlock' : 'Lock';
        this.days = this.getDiffDays(data.lockedDetails.lockedDate);
        this.checked = data.checked ? data.checked : false;
        this.comment = data.unlockRequest.comment ? data.unlockRequest.comment : '';
        this.requestedFlag = data.unlockRequest.Requested ? data.unlockRequest.Requested : false;
        this.reason = data.lockedDetails.reason ? data.lockedDetails.reason : '';
    }
    getDiffDays(date) {
        const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
        const firstDate = new Date(date);
        const secondDate = new Date();
        const diffDays = Math.round(Math.abs((firstDate.getTime() - secondDate.getTime()) / (oneDay)));
        return diffDays;
    }
}


// WEBPACK FOOTER //
// ./src/app/rm/non-adherence-list/non-adherence-list.ts